module.exports = __webpack_public_path__ + "img/use_human_yellow_2.a71d2aac.png";